import { Grid } from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useHistory, useLocation, useParams } from "react-router";
import { Context } from "../../../states/Store";
import { ERROR, Subscription, ThirdpartyScoresOptions, UserInvitationStatus } from '../../../services/common/Constants';
import i18next from "i18next";
import {
  getThirdparty,
  getThirdpartyDocuments, 
  getThirdPartyIndicators,
  getThirdPartyScores,
  getTPContacts,
} from "../../../services/edge/ThirdpartyService";
import {
  getAllNoteTP,
  createNoteTP,
  updateNoteTP,
  deleteNoteTP
} from "../../../services/edge/NoteService";
import {
  formatDate,
  formatNumber,
  formatNumberCurrency,
  getActivityOriginFromType, hasAnyOption,
  hasOption,
} from '../../../services/common/Utils';
import useStyles from "../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import ThirdpartyStopDialog from "./ThirdpartyStopDialog";
import { getDossiersByCriteria } from "../../../services/edge/DossierService";
import { PrivilegeEnum, RoleBasedAccessControlContext } from "../../../services/common/RolesUtils";
import { isEmpty } from "lodash";
import { canAnswerDocument, isUpdatableDocument } from "services/common/DocumentUtils";
import { InitialDocumentsTableSort } from "components/documents/DocumentsDataTableUtils";
import _ from "lodash";
import { useAuth } from "@ea-webapp/auth";
import DossierSection from '../../../components/thirdparties/sheet/accordionSection/DossierSection';
import DocumentSection from '../../../components/thirdparties/sheet/accordionSection/DocumentSection';
import ContactSection from '../../../components/thirdparties/sheet/accordionSection/ContactSection';
import ArchiveSection from '../../../components/thirdparties/sheet/accordionSection/ArchiveSection';
import NoteSection from '../../../components/thirdparties/sheet/accordionSection/NoteSection';
import StickyMenu from '../../../components/thirdparties/sheet/StickyMenu';
import ArchiveAndAuditPistButton from '../../../components/thirdparties/sheet/ArchiveAndAuditPistButton';
import HeaderInformation from '../../../components/thirdparties/sheet/HeaderInformation';
import IndicatorSection from '../../../components/common/IndicatorSection';
import RiskSection from '../../../components/thirdparties/sheet/accordionSection/RiskSection';
import AttributeSection from '../../../components/thirdparties/sheet/accordionSection/AttributeSection';
import DataHubSection from '../../../components/thirdparties/sheet/accordionSection/DataHubSection';
import { navigationItems } from './ThirdpartySheetUtils';
import ThirdpartyUpdateDialog from '../../../components/thirdparties/ThirdpartyUpdateDialog';
import ThirdpartyInformations from '../../../components/thirdparties/ThirdpartyInformations';
import ContexteSection from "components/thirdparties/sheet/accordionSection/ContexteSection";

const fetchThirdpartyDossiers = async (monitored, account, thirdparty) => {
  if (account && thirdparty) {
    try {
      let searchCriteria = `page=0&pageSize=9999&withAttributes=true&monitored=${monitored}&thirdpartyId=${thirdparty.thirdpartyId}`;
      const results = await getDossiersByCriteria(
        account.id,
        searchCriteria,
        null
      );
      // Order results by Creation Date
      let resultsOrdered = results.content.sort(
        (a, b) => new Date(b.creationDate) - new Date(a.creationDate)
      );
      return resultsOrdered;
    } catch (error) {
      return [];
    }
  }
};

// Si un tpId est fournis, cela veut dire que le composant est intégré dans la popUp sur la page liste des tiers
function TPSheet({ tpId, currentSectionFromTPPanel, setCurrentSectionFromTPPanel, scrollRefPanel, denominationRef }) {
  const { classes } = useStyles();
  let { thirdpartyId: thirdpartyIdParam } = useParams();
  const thirdpartyId = tpId || thirdpartyIdParam;
  const [state, dispatch] = useContext(Context);
  const { hasAnyOfPrivileges, hasAnyOfPrivilegesOnScopedResourceImpl } = React.useContext(RoleBasedAccessControlContext);
  const { authState } = useAuth();

  const [thirdparty, setThirdparty] = useState();
  const [contacts, setContacts] = React.useState([]);

  const [balanceSheetData, setBalanceSheetData] = React.useState([]);
  const [isStopDialogOpen, setIsStopDialogOpen] = useState(false);
  const [principals, setPrincipals] = React.useState([]);
  const [loaderContacts, setLoaderContacts] = React.useState(true);

  const [thirdpartyDocuments, setThirdpartyDocuments] = useState([]);
  const [answerCount, setAnswerCount] = useState(0);
  const [tpVisibleDocsCount, setTpVisibleDocsCount] = useState(null);
  const [tpVisibleDossCount, setTpVisibleDossCount] = useState(null);
  const [tpVisibleContactsCount, setTpVisibleContactsCount] = useState(null);
  const [thirdpartyActiveDossiers, setThirdpartyActiveDossiers] = useState();
  const [thirdpartyArchives, setThirdpartyArchives] = useState();
  const [isCreateContactDialogOpen, setIsCreateContactDialogOpen] = useState(false);
  const [thirdpartyRisks, setThirdpartyRisks] = useState();
  const [thirdpartyIndicators, setThirdpartyIndicators] = useState();
  const [tpNotes, setTPNotes] = useState();
  const [sortModel, setSortModel] = useState(InitialDocumentsTableSort);
  const [isUnmanaged, setIsUnmanaged] = useState(false);
  const [currentSection, setCurrentSection] = useState(navigationItems[0].sectionId);
  const ref = useRef();

  const [thirdpartyCode, setThirdpartyCode] = useState(null);
  const [isUpdateThirdPartyDialogOpen, setIsUpdateThirdPartyDialogOpen ] = useState(false);
  const [isOpenInformationPopup, setIsOpenInformationPopup ] = useState(false);

  useEffect(() => {
      setThirdpartyCode(thirdparty?.thirdpartyCode || null);
  }, [thirdparty]);

  const concactsDataTableRef = useRef();

  const hasAnyOfPrivilegesOnScopedResource = useCallback((...privileges) => {
    let result = false;

    if (thirdparty) {
      result = hasAnyOfPrivilegesOnScopedResourceImpl(thirdparty, ...privileges);
    }

    return result;
  }, [thirdparty, hasAnyOfPrivilegesOnScopedResourceImpl]);

  const history = useHistory();
  let location = useLocation();

  const fetchThirdPartyScores = useCallback(() => {
    async function getScorings() {
      try {
        const result = await getThirdPartyScores(
          state.account.id,
          thirdpartyId,
          dispatch
        );

        setThirdpartyRisks(result.content);

      } catch (error) {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "THIRDPARTY_NOT_FOUND" },
        });
      }
    }

    if (state.account) {
      getScorings();
    }
  }, [dispatch, state.account, thirdpartyId]);

  const fetchThirdpartyInfos = useCallback(() => {
    async function getThirdpartyInfos() {
      try {
        const result = await getThirdparty(
          state.account.id,
          thirdpartyId,
          dispatch
        );
        const activityOrigin = getActivityOriginFromType(result.content.etabActivityType)
        const activityTranslated = state.activityMapByOrigin.get(activityOrigin)?.get(result.content.etabActivityCode)
        const activityLabel = activityTranslated ? activityTranslated.description : result.content.etabActivityLabel
        setIsUnmanaged(result.content.companyIdType === "CIT004")
        setThirdparty({
              ...result.content,
              etabActivityLabel: activityLabel,
              legalCategoryLabel: state.legalActivityTraductions[result.content.legalCategoryCode] || result.content.legalCategoryLabel
        })
        if (!tpId){
          dispatch({
            type: "CRUMBS",
            crumbsData: {
              lastCrumbs: [{ label: result.content.name, disableTranslation: true }],
            },
          });
        }
        dispatch({
          type: "SELECTED_THIRDPARTY",
          thirdparty: result.content,
        });

        // Map balance Sheet Data
        setBalanceSheetData([
          {
            id: 1,
            balanceSheetDate: formatDate(result.content.lastBalanceSheetDate),
            turnover: formatNumberCurrency(
              result.content.turnover,
              result.content.turnoverCurrency
            ),
            workforce: formatNumber(result.content.workforce),
          },
        ]);

        // Map principals
        let mappedPrincipals = result.content.principals?.map((p, i) => {
          return {
            id: i,
            ...p,
          };
        });
        setPrincipals(mappedPrincipals);

        // Thirdparty Scorings (indueD, Transparency, Financial Strength, etc.)
        fetchThirdPartyScores();

      } catch (error) {
        console.error(error);
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "THIRDPARTY_NOT_FOUND" },
        });
      }
    }

    async function getIndicators() {
      try {
        const result = await getThirdPartyIndicators(
          state.account.id,
          thirdpartyId,
          dispatch
        );
        const sortedIndicators = result?.content?.sort((a,b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
        setThirdpartyIndicators(sortedIndicators)
      } catch (e) {
        dispatch({
          type: "ALERT",
          alert: { type: ERROR, msg: "THIRDPARTY_NOT_FOUND" },
        });
      }
    }

    if (state.account && authState.user) {
      getThirdpartyInfos();
      getIndicators();
    }
  }, [state.account, authState.user, thirdpartyId, fetchThirdPartyScores, tpId,
    state.legalActivityTraductions, dispatch, state.activityMapByOrigin]);

    const changeShownTpCode = (tpCode) => {
    setThirdpartyCode(tpCode);
  };

  const fetchTPNotes = useCallback(() => {
    async function getTPNotes() {
      try {
        const result = await getAllNoteTP(
          state.account.id,
          thirdpartyId,
          null
        );
        setTPNotes(result.content);
      } catch (error) {
        setTPNotes(null);
      }
    }

    if (state.account && thirdpartyId && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_NOTES)) {
      getTPNotes();
    } else {
      setTPNotes(null);
    }
  }, [thirdpartyId, state.account, hasAnyOfPrivilegesOnScopedResource]);

  useEffect(() => {
    fetchTPNotes()
  }, [fetchTPNotes]);

  const updateNoteTPCallback = useCallback(async (noteOId, noteContent) => {
    await updateNoteTP(state.account.id, thirdpartyId, noteOId, noteContent);

  }, [state.account, thirdpartyId]);

  const createNoteTPCallback = useCallback(async (noteContent) => {
    await createNoteTP(state.account.id, thirdpartyId, noteContent);

  }, [state.account, thirdpartyId]);

  const deleteNoteTPCallback = useCallback(async (noteOId) => {
    await deleteNoteTP(state.account.id, thirdpartyId, noteOId);

  }, [state.account, thirdpartyId]);

  // Fetch Third party informations
  useEffect(() => {
    fetchThirdpartyInfos();
  }, [fetchThirdpartyInfos]);

  const fetchContacts = useCallback(() => {
    if (state.account && thirdparty?.onboarded) {
      setLoaderContacts(true);
      (async function fetchData() {
        try {
          const resp = await getTPContacts(
            state.account.id,
            thirdparty.thirdpartyId,
            dispatch
          );

          // Map thirdparties
          let mappedContacts = resp?.content?.map((user) => {
            return {
              ...user,
              id: user.pcuId,
              status: mapUserStatus(user),
              name: user.lastName,
              firstname: user.firstName,
              invitationdate: user.invitationDate,
              lastactivitydate: user.lastActivityDate,
              tpname: user.tpName,
              tpid: user.tpId,
              tpaccountid: user.tpAccountId,
            };
          });
          setLoaderContacts(false);
          setContacts(mappedContacts);
          dispatch({
            type: "SELECTED_THIRDPARTY_CONTACTS",
            thirdpartyContacts: mappedContacts,
          });
        } catch (e) {
          if (!e?.message.messages?.error) {
            dispatch({
              type: "ALERT",
              alert: { type: ERROR, msg: "INTERNAL_ERROR" },
            });
          }
          setLoaderContacts(false);
        }
      })();
    }
  }, [thirdparty, dispatch, state.account]);

  const mapUserStatus = (user) => {
    if (user.status === "INSCRIT") {
      return UserInvitationStatus.REGISTERED;
    } else if (user.status === "INVITE") {
      return UserInvitationStatus.INVITED;
    } else if (user.status === "DECLINED") {
      return UserInvitationStatus.DECLINED;
    } else {
      return UserInvitationStatus.EXPIRED_INVITATION;
    }
  }

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  // Fetch Onboarded Third party Active Dossiers
  useEffect(() => {
    async function searchThirdpartyDossiers() {
      const dossiersMonitored = await fetchThirdpartyDossiers(
        true,
        state.account,
        thirdparty
      );
      setThirdpartyActiveDossiers(dossiersMonitored);
    }
    if (state.account && thirdparty?.onboarded) {
      searchThirdpartyDossiers();
    }
  }, [state.account, thirdparty]);

  // Fetch Onboarded Third party Archives
  useEffect(() => {
    async function searchThirdpartyDossiers() {
      const dossiersArchived = await fetchThirdpartyDossiers(
        false,
        state.account,
        thirdparty
      );
      setThirdpartyArchives(dossiersArchived);
    }
    if (state.account && thirdparty) {
      searchThirdpartyDossiers();
    }
  }, [state.account, thirdparty]);

  // Fetch Third party Documents
  useEffect(() => {
    async function getDocuments() {
      try {
        const result = await getThirdpartyDocuments(
          state.account.id,
          thirdparty.thirdpartyId
        );

        let responses = result.content
          // We concat both evidences while excluding evidences that have been stopped, to show other reasons
          .map((doc) => ({
            ...doc,
            evidences: [].concat(
              doc.evidences,
              doc.historicEvidences?.filter(
                (e) => e.statusReason !== "ARRET_DEMANDE"
              )
            ),
          }))
          .map((x) => {
            return {
              ...x,
              documentId: x.documentId,
              reponseId: x.evidences?.[0]?.responseId,
              fileId: x.evidences?.[0]?.id,
              depositorName: x.evidences?.[0]?.metadata?.depositor,
              transmitter: x.evidences?.[0]?.transmitter,
              docName: x.documentName,
              depositDate: x.evidences?.[0]?.uploadDate,
              endDate: x.evidences?.[0]?.expirationDate,
              present: x.evidences?.length > 0,
              thirdpartyId: thirdparty.thirdpartyId,
              statusCode: x.statusCode,
              authorizingRoles: x.authorizingRoles,
              typeDocumentId: x.typeDocumentId,
              acquisition: x.acquisition,
              dossierId: x.dossierId,
              dossierReference: x.dossierReference,
              dossierTypeLibelle: x.dossierTypeLibelle,
              isAnswerable: canAnswerDocument(x) && thirdparty.onboarded,
              refusedToFile: x.evidences?.[0]?.hasRefusedToFile,
              nbMultiple: x.nbMultiple
            };
          });
        responses = responses.filter(
          (value, index, self) => {
            if (value.acquisition === "DO") {
              return true;
            } else {
              return index === self.findIndex(
                (t) =>
                  t.reponseId === value.reponseId &&
                  t.docName === value.docName &&
                  t.thirdpartyName === value.thirdpartyName
              );
            }
          }
        );

        setThirdpartyDocuments(responses);
      } catch (error) {
        setThirdpartyDocuments([]);
      }
    }

    if (state.account && thirdparty?.onboarded) {
      getDocuments();
    }
  }, [thirdparty, state.account, state.lang, state.doctypeTraductions,]);

  useEffect(() => {
    setAnswerCount(thirdpartyDocuments?.filter((x) => (x.isAnswerable === true && !isUpdatableDocument(x)))?.length || 0);
  }, [thirdpartyDocuments])

  useEffect(() => {
    const handleScroll = _.debounce(() => {
      for (const section of navigationItems) {
        const element = document.getElementById(section.sectionId);
        if (element) {
          const rect = element?.getBoundingClientRect();
          if (rect?.top <= 260 && rect?.bottom > 260) {
            setCurrentSection(section.sectionId);
          }
        }
      }

      // Au-dessus de la premiere section
      const firstSection = document.getElementById(navigationItems[0].sectionId)?.getBoundingClientRect();
      if (firstSection?.top > 230){
        setCurrentSection(navigationItems[0].sectionId);
      }
      // En dessous de la dernière section
      const lastSection = document.getElementById(navigationItems[navigationItems.length - 1].sectionId)?.getBoundingClientRect();
      if (lastSection?.bottom < 300) {
        setCurrentSection(navigationItems[navigationItems.length - 1].sectionId);
      }

    }, 10);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const handleReinviteContactsPopup = (user) => {
    concactsDataTableRef.current?.handleReinviteContactsPopup(user);
  }

  return (
    <div style={{maxWidth: "calc(100vw - 250px)"}}>
      {thirdparty && (
        <div className={classes.root}>
          <Grid container className={ (state.personalization.isCustomTemplate || !thirdparty.onboarded) ? classes.headerBackgroundNoTheme : classes.headerBackground } >
            <Grid container item xs={12} style={{paddingTop: tpId ? "70px" : 0, position: "relative"}}>
              <HeaderInformation
                thirdparty={thirdparty}
                isUnmanaged={isUnmanaged}
                tpId={tpId || thirdpartyIdParam}
                thirdpartyCode={thirdpartyCode}
                setThirdpartyCode={setThirdpartyCode}
                isUpdateThirdPartyDialogOpen={isUpdateThirdPartyDialogOpen}
                setIsUpdateThirdPartyDialogOpen={setIsUpdateThirdPartyDialogOpen}
                setIsOpenInformationPopup={setIsOpenInformationPopup}
                changeShownTpCode={changeShownTpCode}
                fromSheet={tpId === undefined}
                denominationRef={denominationRef}
                hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
              />
              <ArchiveAndAuditPistButton
                thirdparty={thirdparty}
                hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
                setIsStopDialogOpen={setIsStopDialogOpen}
                tpId={tpId}
              />
            </Grid>
          </Grid>

          {/* Navigation sous section */}
          <StickyMenu
            hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
            hasAnyOfPrivileges={hasAnyOfPrivileges}
            thirdpartyRisks={hasAnyOption(state.accounts, state.account.id, ThirdpartyScoresOptions) ? thirdpartyRisks : null}
            thirdparty={thirdparty}
            state={state}
            fromPanel={tpId !== undefined}
            currentSection={tpId !== undefined ? currentSectionFromTPPanel : currentSection}
            setCurrentSection={tpId !== undefined ? setCurrentSectionFromTPPanel : setCurrentSection}
            scrollRefPanel={scrollRefPanel || null}
          />

          {/* Sous section */}
          <AttributeSection
            title={i18next.t("thirdpartySheet.theAttributes")}
            display={hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE_VALUE, PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_CALCULATED_ATTRIBUTE) 
              || (hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_THIRD_PARTY) && hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_ATTRIBUTE_VALUE))
            }
            id={thirdpartyId}
            bondType="thirdparty"
            hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
          />

          <IndicatorSection
            hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
            indicators={thirdpartyIndicators}
            title={i18next.t("thirdpartySheet.theIndicators")}
            display={hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_INDICATOR)}
          />

          <RiskSection
            display={hasAnyOption(state.accounts, state.account.id, ThirdpartyScoresOptions)}
            //TODO : faut-il rajouer hasAnyOfPrivilegesOnScopedResource(PRIVILEGE_VIEW_THIRD_PARTY_RISKS) ? Ce privilege n'est actuellement pas utilisé
            title={i18next.t("thirdpartySheet.thirdpartyEval")}
            risks={thirdpartyRisks}
            onRiskChange={() => fetchThirdpartyInfos()}
            thirdPartyId={thirdparty.thirdpartyId}
            contacts={contacts}
            isUnmanaged={isUnmanaged}
            isExpanded={!isEmpty(thirdpartyRisks)}
          />

          <DataHubSection
            display={hasOption(state.accounts, state.account.id, Subscription.DATA_HUB) && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_DATA_HUB_SOURCE)}
            title={i18next.t("thirdpartySheet.dataHub.title")}
            thirdPartyId={thirdparty.thirdpartyId}
            isUnmanaged={isUnmanaged}
          />

          {/*TODO V2 si/quand RiskSection éclaté -------
          <OwlinSection
            title={i18next.t('owlin.label')}
            display={hasOption(state.accounts, state.account.id, "OWLIN") && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_OWLIN_SOURCE)}
            thirdPartyId={tpId || thirdpartyId}
          />

          <ESGSection
            display={esgData && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_DNB_ESG_SOURCE)}
            title={i18next.t('ESG.label')}
            esgData={esgData}
            evolutionESG={evolutionESG}
            thirdPartyId={tpId || thirdpartyId}
            fetchThirdpartyInfos={fetchThirdpartyInfos}
            thirdpartyRisks=thirdpartyRisks
          />

          <EcovadisSection
            title={i18next.t('ecovadis.EVratings')}
            display={hasOption(state.accounts, state.account.id, "ECOVADIS") && thirdpartyRisks?.ecovadis && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_ECOVADIS_SOURCE)}
            fetchThirdpartyInfos={fetchThirdpartyInfos}
            thirdpartyRisks={thirdpartyRisks}
          />
          TODO FIN -----------------------------------*/}

          <ContexteSection
            thirdpartyId={thirdpartyId}
            display={thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
                  PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT,
                  PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_INFORMATION,
                  PrivilegeEnum.PRIVILEGE_VIEW_CONTEXT_ATTRIBUTES
                )}
            thirdpartyActiveDossiers={thirdpartyActiveDossiers}
          />

          <DossierSection
            fetchThirdpartyInfos={fetchThirdpartyInfos}
            display={thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER,
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INFORMATION,
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE_VALUE
            )}
            title={i18next.t('monitoredDossiers')}
            setTpVisibleDossCount={setTpVisibleDossCount}
            tpVisibleDossCount={tpVisibleDossCount}
            thirdpartyActiveDossiers={thirdpartyActiveDossiers}
            thirdparty={thirdparty}
            accountId={state.account.id}
            hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
            history={history}
            location={location}
            ref={ref}
          />

          <DocumentSection
            title={i18next.t('requestedDocuments')}
            display={thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_DOCUMENT)}
            answerCount={answerCount}
            setTpVisibleDocsCount={setTpVisibleDocsCount}
            tpVisibleDocsCount={tpVisibleDocsCount}
            thirdpartyDocuments={thirdpartyDocuments}
            sortModel={sortModel}
            setSortModel={setSortModel}
            thirdparty={thirdparty}
          />

          <ContactSection
            contacts={contacts}
            display={thirdparty.onboarded && hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_CONTACT)}
            hasAnyOfPrivilegesOnScopedResource={hasAnyOfPrivilegesOnScopedResource}
            thirdparty={thirdparty}
            isCreateContactDialogOpen={isCreateContactDialogOpen}
            setIsCreateContactDialogOpen={setIsCreateContactDialogOpen}
            loaderContacts={loaderContacts}
            setTpVisibleContactsCount={setTpVisibleContactsCount}
            tpVisibleContactsCount={tpVisibleContactsCount}
            fetchContacts={fetchContacts}
            thirdpartyId={tpId || thirdpartyId}
            title={i18next.t('contactsTable.title')}
            onReinviteUser={handleReinviteContactsPopup}
            concactsDataTableRef={concactsDataTableRef}
          />

          <NoteSection
            tpNotes={tpNotes}
            fetchTPNotes={fetchTPNotes}
            display={hasAnyOfPrivilegesOnScopedResource(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_NOTES)}
            title={i18next.t('notes.title')}
            createNoteTPCallback={createNoteTPCallback}
            updateNoteTPCallback={updateNoteTPCallback}
            hasAnyOfPrivileges={hasAnyOfPrivileges}
            deleteNoteTPCallback={deleteNoteTPCallback}
          />

          <ArchiveSection
            title={i18next.t('archives')}
            display={hasAnyOfPrivilegesOnScopedResource(
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER,
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_INFORMATION,
              PrivilegeEnum.PRIVILEGE_VIEW_DOSSIER_ATTRIBUTE_VALUE
            )}
            thirdpartyArchives={thirdpartyArchives}
          />

          {/* Pop up */}
          {isStopDialogOpen &&
            hasAnyOfPrivilegesOnScopedResource(
              PrivilegeEnum.PRIVILEGE_ARCHIVE_THIRD_PARTY
            ) && (
              <ThirdpartyStopDialog
                thirdpartyId={thirdparty.thirdpartyId}
                isOpen={isStopDialogOpen}
                handleClose={() => setIsStopDialogOpen(false)}
              />
            )}

          {isUpdateThirdPartyDialogOpen &&
            hasAnyOfPrivilegesOnScopedResource(
              PrivilegeEnum.PRIVILEGE_EDIT_THIRD_PARTY_CODE
            ) && (
              <ThirdpartyUpdateDialog
                isOpen={isUpdateThirdPartyDialogOpen}
                tpCode={thirdpartyCode}
                onTpCodeChange={changeShownTpCode}
                handleClose={() => setIsUpdateThirdPartyDialogOpen(false)}
                thirdpartyId={thirdpartyId}
              />
            )}

          {isOpenInformationPopup &&
            <ThirdpartyInformations
              thirdparty={thirdparty}
              isUnmanaged={isUnmanaged}
              fetchThirdpartyInfos={() => fetchThirdpartyInfos()}
              thirdpartyCode={thirdpartyCode}
              setThirdpartyCode={setThirdpartyCode}
              isUpdateThirdPartyDialogOpen={isUpdateThirdPartyDialogOpen}
              setIsUpdateThirdPartyDialogOpen={setIsUpdateThirdPartyDialogOpen}
              principals={principals}
              balanceSheetData={balanceSheetData}
              isOpen={isOpenInformationPopup}
              handleClose={() => setIsOpenInformationPopup(false)}
              onTpCodeChange={changeShownTpCode}
            />
          }
        </div>
      )}
    </div>
  );
}
export default TPSheet;


